// extracted by mini-css-extract-plugin
module.exports = {"section":"Iz49e","scoreboard":"_1HueV","cta":"_14b2Z","cmsButtons":"_2Xd7f","ctaLink":"_3TLlB","bannerTitle":"_1GL1U","competitionLogo":"_19Xk0","fadeIn":"_2yq2D"};